import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/pages/1bfs/bfs-page-content.tsx");
